import PropTypes from "prop-types";
import style from "./styles";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import heroImage from "../../assets/premier-hero-model.jpg";
import logoDark from "../../assets/asos-premier-2.png";
import logoWhite from "../../assets/asos-premier-logo-white.png";

const PremierHero = ({ highReturner: locked, apiTitle }) => {
  const translate = useTranslate(useLocaleProvider());
  const title = apiTitle || translate("premier_landingpage_hero_title");
  const cta = translate("premier_landingpage_hero_cta");

  const renderCta = () =>
    locked ? (
      <span
        className={`${style.HeroCta} ${style.HeroCtaDisabled}`}
        role="link"
        aria-disabled="true"
        data-hero-cta
      >
        {cta}
      </span>
    ) : (
      <a className={style.HeroCta} href="#plans" data-hero-cta>
        {cta}
      </a>
    );

  return (
    <section className={style.PremierHero}>
      <div className={style.HeroMobile}>
        <div className={style.HeroMobileMedia}>
          <img
            className={style.HeroImage}
            src={heroImage}
            alt="Model styled with ASOS Premier next-day delivery"
          />
          <div className={style.HeroOverlay} />
          <div className={style.HeroMobileContent}>
            <img
              className={style.HeroLogoWhite}
              src={logoWhite}
              alt="ASOS Premier"
            />
            <h1 className={style.HeroTitle}>{title}</h1>
            <div className={style.HeroCtaWrap}>{renderCta()}</div>
          </div>
        </div>
      </div>

      <div className={style.HeroDesktop}>
        <div className={style.HeroDesktopInner}>
          <div className={style.HeroGrid}>
            <div className={style.HeroCopy}>
              <img
                className={style.HeroLogoDark}
                src={logoDark}
                alt="ASOS Premier"
              />
              <h1 className={style.HeroTitle}>{title}</h1>
              <div className={style.HeroCtaWrap}>{renderCta()}</div>
            </div>
            <div className={style.HeroMediaDesktop}>
              <img
                className={style.HeroImage}
                src={heroImage}
                alt="Model styled with ASOS Premier next-day delivery"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

PremierHero.propTypes = {
  highReturner: PropTypes.bool,
  apiTitle: PropTypes.string,
};

export default PremierHero;
